var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcrTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10997_253507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#BD00FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10997_253507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.71621 14C4.33121 14 4.00163 13.8629 3.72746 13.5888C3.45329 13.3146 3.31621 12.985 3.31621 12.6V4.1C3.12732 4.1 2.96343 4.03056 2.82454 3.89167C2.68566 3.75278 2.61621 3.58889 2.61621 3.4C2.61621 3.21111 2.68566 3.04722 2.82454 2.90833C2.96343 2.76944 3.12839 2.7 3.31941 2.7H6.01621C6.01621 2.51111 6.08566 2.34722 6.22454 2.20833C6.36343 2.06944 6.52732 2 6.71621 2H9.26621C9.4551 2 9.61899 2.06944 9.75788 2.20833C9.89677 2.34722 9.96621 2.51111 9.96621 2.7H12.663C12.854 2.7 13.019 2.76944 13.1579 2.90833C13.2968 3.04722 13.3662 3.21111 13.3662 3.4C13.3662 3.58889 13.2968 3.75278 13.1579 3.89167C13.019 4.03056 12.8551 4.1 12.6662 4.1V12.6C12.6662 12.985 12.5291 13.3146 12.255 13.5888C11.9808 13.8629 11.6512 14 11.2662 14H4.71621ZM4.71621 4.1V12.6H11.2662V4.1H4.71621ZM5.96621 10.5C5.96621 10.6889 6.03566 10.8528 6.17454 10.9917C6.31343 11.1306 6.47732 11.2 6.66621 11.2C6.8551 11.2 7.01899 11.1306 7.15788 10.9917C7.29677 10.8528 7.36621 10.6889 7.36621 10.5V6.2C7.36621 6.01111 7.29677 5.84722 7.15788 5.70833C7.01899 5.56944 6.8551 5.5 6.66621 5.5C6.47732 5.5 6.31343 5.56944 6.17454 5.70833C6.03566 5.84722 5.96621 6.01111 5.96621 6.2V10.5ZM8.61621 10.5C8.61621 10.6889 8.68566 10.8528 8.82454 10.9917C8.96343 11.1306 9.12732 11.2 9.31621 11.2C9.5051 11.2 9.66899 11.1306 9.80788 10.9917C9.94677 10.8528 10.0162 10.6889 10.0162 10.5V6.2C10.0162 6.01111 9.94677 5.84722 9.80788 5.70833C9.66899 5.56944 9.5051 5.5 9.31621 5.5C9.12732 5.5 8.96343 5.56944 8.82454 5.70833C8.68566 5.84722 8.61621 6.01111 8.61621 6.2V10.5Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrTrash);
export default __webpack_public_path__ + "static/media/ocr-trash.3550906c465413c5cc7f9c24f2ee92f3.svg";
export { ForwardRef as ReactComponent };